import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  getSingleUseToken({ commit }) {
    return colonyAPI
      .get('tokens/single-use/')
      .then(response => commit(types.GET_SINGLE_USE_TOKEN_SUCCESS, response.data))
      .catch(error => commit(types.GET_SINGLE_USE_TOKEN_FAILURE, error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/tokens/actions.js